import { Component, inject, input, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { firstValueFrom } from 'rxjs';
import { MachineMeasurementsValueDto } from 'src/app/shared/dto/machine-measurements-value.dto';
import { SensorDto } from 'src/app/shared/dto/sensor.dto';
import { MachineMeasurementsValueService } from '../../services/machine-measurements-value.service';
import { ConfigurationDto } from 'src/app/shared/dto/configuration.dto';
import { MachineMeasurementsEnum } from 'src/app/shared/enums/machine-measurements.enum';

@Component({
    selector: 'app-sensor-card',
    standalone: true,
    imports: [
        NzCardComponent,
        NzProgressModule,
        NzToolTipModule
    ],
    templateUrl: './sensor-card.component.html',
    styleUrl: './sensor-card.component.scss'
})

export class SensorCardComponent implements OnInit, OnChanges {
    private readonly machineMeasurementsValueService = inject(MachineMeasurementsValueService);
    @Input() sensor: SensorDto | undefined;
    @Input() articleId?: number;
    @Input() size!: string;
    @Input() cardStyle: string = "background:rgb(255, 255, 255); padding: 12px !important; filter: drop-shadow(0 4px 4px rgb(0 0 0 / 0.15));";

    quantityToProduce = input(0);
    machineMeasurementsValues: MachineMeasurementsValueDto[] = [];
    thresholdConfig: ConfigurationDto | undefined;
    velocityReferenceValue: string = '';

    async ngOnInit() {

        if (this.sensor?.id && this.articleId) {
            this.machineMeasurementsValues = await firstValueFrom(this.machineMeasurementsValueService.findBySensorIdAndArticleId(this.sensor.id, this.articleId));
            const a = 0;
        } else if (this.sensor?.id) {
            this.machineMeasurementsValues = await firstValueFrom(this.machineMeasurementsValueService.findBySensor(this.sensor?.id));
        }

        //!!
        //TODO: avoid call with literal string
        if (this.sensor?.name === 'Corte') {
            this.velocityReferenceValue = this.machineMeasurementsValues.find(value => MachineMeasurementsEnum.VELOCITY === value.machineMeasurement?.measurement)?.value ?? '';
        }
    }

    //!!
    //TODO: check why field value is undefined
    ngOnChanges(changes: SimpleChanges) {
        if (changes['sensor'] && changes['sensor'].currentValue) {
            const current = changes['sensor'].currentValue;
            const prev = changes['sensor'].previousValue;

            if (current.value === undefined && prev && prev.value !== undefined) {
                current.value = prev.value;
            }
            
            console.log('Sensor changed:', current);
        }
    }

    getSensorColor(sensorValue: number): string {
        let color = '#000000';

        switch (this.sensor?.name) {
            case 'Corte':
                color = this.getVelocitySensorColor(sensorValue);
                break;
            case 'Acumulado cortes':
                color = this.getAccumulatedSensorColor(sensorValue);
                break;
        }

        return color;
    }

    private getVelocitySensorColor(sensorValue: number | undefined): string {
        let color = '';

        if (!sensorValue || this.velocityReferenceValue === '' || Number(this.velocityReferenceValue) === sensorValue) {
            return '#000000';
        }

        color = sensorValue > Number(this.velocityReferenceValue) ? '#00c853' : '#d32f2f';
        return color;
    }

    private getAccumulatedSensorColor(sensorValue: number): string {
        return sensorValue >= this.quantityToProduce() ? '#00c853' : '#000000';
    }

}
